export default __webpack_public_path__ + "static/media/NationalStandards_WorkingGroup.5e585490.pdf";